export default __webpack_public_path__ + "static/media/Photo 6 - MR - inertie thermique.239d564d.jpg";